export const USER_UNAUTHORIZED = 'user is not authorized';
export const CATEGORY_ID_UNAVAILABLE = 'category id is unavailable';
export const UNKNOWN_ERROR = 'something went wrong';